import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-back-button',
  standalone: true,
  templateUrl: './back-button.html',
  styleUrl: './back-button.scss',
  imports: [
    Button,
    Tooltip,
    TranslatePipe,
  ],
})
export class BackButton {
  @Input() parentRoute: string = '';
  @Input() title: string | undefined = '';
  @Input() subtitle!: string;
  @Input() loading: boolean = false;
  @Output() back = new EventEmitter<void>();

  constructor( private router: Router) {}

  goBack(): void {
    if (this.back.observed) {
      this.back.emit();
      return;
    }

    if (this.parentRoute) {
      this.router.navigate([this.parentRoute]);
      return;
    }
    const currentPath = this.router.url.split(/[?#]/)[0];
    const segments = currentPath.split('/').filter(Boolean);

    if (segments.length > 0) {
      segments.pop();
      const destination = segments.length > 0 ? `/${segments.join('/')}` : '/';
      this.router.navigateByUrl(destination);
    } else {
      this.router.navigate(['/']);
    }
  }
}
